module.exports = __webpack_public_path__ + "static/img/frutuba-laranja.dc643e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/thumbs/frutuba-laranja.png
// module id = yUyM
// module chunks = 0